import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询广告套餐
export const getAnnouncementList = params => {
    return reqGet("get", "/app-yijiu-backstage/getAnnouncementList", params);
};

// 删除广告套餐
export const deleteAnnouncement = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteAnnouncement", params);
};

  // 增加广告套餐
export const addAnnouncement = params => {
    return req("post", "/app-yijiu-backstage/addAnnouncement", params);
};

  // 修改广告套餐
  export const updateAnnouncement = params => {
    return req("post", "/app-yijiu-backstage/updateAnnouncement", params);
};


// WEBPACK FOOTER //
// ./src/api/manage/announcement.js